<template> <NavBar v-if="curpage != 0"> 
     <template v-slot:action>
       <li> <a class="dropdown-item" @click="start_interval()">Start Interval</a> </li>
       <li> <a class="dropdown-item" @click="stop_interval()">Stop Interval</a> </li>
     </template>
     <template v-slot:screen>
       <li> <a class="dropdown-item" role="button" @click="change_page(1)">Main Screen</a></li>
       <li> <a v-if="adminlvl & 1" class="dropdown-item" role="button" @click="change_page(2)">Swap Monitor</a> </li>

       <!-- li v-if="adminlvl >= 2"><hr class="dropdown-divider"></li> -->
       <li v-if="adminlvl & 2"> <a class="dropdown-item" role="button" 
                @click="change_page(3)">Control Panel</a> </li>
       <li v-if="adminlvl & 4"> <a class="dropdown-item" role="button" 
                @click="change_page(4)">Key Input</a> </li>
       <li v-if="adminlvl & 8"> <a class="dropdown-item" role="button" 
                @click="change_page(5)">User Maker</a> </li>
       <li v-if="adminlvl & 16"> <a class="dropdown-item" role="button" 
                @click="change_page(6)">User Approval</a> </li>
       <!--
       <li> <a class="dropdown-item" role="button" 
                @click="change_page(7)">test BootStrap</a> </li> -->
     </template>
     <template v-slot:monitor>
            <li v-for="screen in layouts" :key="screen.pagenum"> 
                <a class="dropdown-item" role="button" @click="change_page(screen.pagenum)">
                {{screen.layout.title}}
                </a>
            </li>
     </template>
     <template v-slot:report>
       <li style='padding:8px;left:10px'> <a class="dropdown-item" role="button" @click="change_page(100)">Report</a> </li>
     </template>
  </NavBar>
  <template v-if="curpage == 0">
    <div class="row">
      <DashLogin msg="Welcome To ProSwitching New Monitor" />
    </div>
  </template>
  <template v-if="curpage == 1">
     <MainScreen ref="MAINSCR"/>
  </template>
  <template v-if="curpage == 2">
    <div class="container-fluid">
      <div class="row g-2">
        <div class="col-md-4" style="height:320px">
            <SpeedoComp ref="SPEEDO02" globid="SPEEDO02" 
             :swapid="current_swap" 
             :period="$store.getters.interval"
             title="ProSW TPS Monitor" /> 
        </div>
        <div class="col-md-4" style="height:320px">
            <LineChart  ref="LINECHART01" globid="LCmain01" 
            :swapid="current_swap" 
            :period="$store.getters.interval"
            subtype="apr" 
            screensize="1x1"/>
        </div>
        <div class="col-md-4" style="height:320px">
            <SwapData ref="SWAPDATA01" globid="SD01" 
            screensize="1x1" 
            :period="$store.getters.interval"
            :swapid="current_swap"/>
        </div>
      </div>
    </div>
    <div v-if="swapseq > 0" class="row g-2">
      <div class="col-md-4" style="height:320px">
         <SwapDir :swapid="current_swap"/>
      </div>
      <div class="col-md-8" style="height:320px">
        <IframeArea ref="IFRAME01" globid="IFRAME01" :swapid="current_swap"/>
      </div>
    </div>
  </template>

  <template v-if="curpage == 3">
    <SwapOperation :swapid="current_swap" />
  </template>

  <template v-if="curpage == 4">
    <KeyInput/>
  </template>

  <template v-if="curpage == 5">
    <UserMgmt/>
  </template>

  <template v-if="curpage == 6">
    <UserUpd/>
  </template>

  <template v-if="curpage == 7">
    <TestBootStrap/>
  </template>

  <template v-if="curpage == 100">
     <ReportScreen ref="REPORTSCR"/>
  </template>

  <template v-for="screen in layouts" :key="screen.pagenum">
    <template v-if="curpage == screen.pagenum">
        <MainLayout :layout=screen.layout />
    </template>
  </template>
  <div style="display: none;"><img id="sprite" src="./assets/newicons.svg"></div>
</template>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.dropdown-menu li {
  position: relative;
}
.dropdown-menu .dropdown-submenu {
  display: none;
  position: absolute;
  left: 100%;
  top: -7px;
}
.dropdown-menu .dropdown-submenu-left {
  right: 100%;
  left: auto;
}
.dropdown-menu > li:hover > .dropdown-submenu {
  display: block;
}
</style>


<script>
import SpeedoComp from './components/SpeedoComp.vue' 
import MainScreen from './components/MainScreen.vue' 
import ReportScreen from './components/ReportScreen.vue' 
import NavBar from './components/NavBar.vue' 
import LineChart from './components/LineChart.vue' 
import IframeArea from './components/IframeArea.vue' 
import SwapDir from './components/SwapDir.vue' 
import DashLogin from './components/DashLogin.vue' 
import SwapData from './components/SwapData.vue' 
import MainLayout from './components/MainLayout.vue'
import SwapOperation from './components/SwapOperation.vue'
import prosw_controller from './assets/controller.json'
import txtable from  './assets/txdata.json' 
import KeyInput from './components/KeyInput.vue'
import UserMgmt from './components/UserMgmt.vue'
import UserUpd from './components/UserUpd.vue'
import TestBootStrap from './components/TestBootStrap.vue'

export default {
  name: 'App',
  components: {
     NavBar, LineChart, SwapDir, MainScreen, ReportScreen, SpeedoComp,
     DashLogin, SwapData, MainLayout, SwapOperation, IframeArea, KeyInput, UserMgmt, UserUpd,
     TestBootStrap
  },
  data() {
      return {
        interval : 0,
        n_glob : 0
      }
  },
  computed: {
    layouts() {
        let res = []
        if ( ! this.$store.getters.screens )
            return res ;

        let screens = this.$store.getters.screens ;
        let pagenum = 10 ;

        for (let i = 0 ; i < screens.length ; i++) {
            res[i] = {
                "layout" : screens[i],
                "pagenum" : pagenum + i 
            }
        }
        return res ;
    },
    current_swap() {
      return this.$store.getters.active_swap.toString() ;
    },
    swapseq() {
      let swap = this.$store.getters.getswap_byid(this.current_swap) ;
      if (! swap) return 0 ;
      return swap.seq ;	
    },
    controllerid() {
        return this.$store.getters.controllerid ;
    },
    curpage() {
        return this.$store.getters.curpage ;
    },
    adminlvl() {
        // this.$store.getters.adminlvl ;
        var access = this.$store.getters.menuaccess ;
        // alert ("current access " + access) ;
        return access ;
    }
  },
  created() {
    let tag = document.createElement("script");
    tag.src = 'prosw/dash/js/controller.js';
    tag.async = false; // optionally
    document.head.appendChild(tag);
    tag.onerror = () => { 
        this.$store.commit('setup', prosw_controller)  ;
    }
    tag.onload = () => {
        this.$store.commit('setup', window.controller)  ;
    }
  },
  mounted() {
    this.$store.commit("set_rootel", this) ;
  },
  methods: {
    dispmaps(layout) {
       return layout.widgets ;
    },

     stop_interval() {
         let allrefs = Object.keys(this.$refs) ;
         for ( let c of allrefs ) {
           let child = this.$refs[c] ;
           if (! child) continue ;
           if (typeof child.stop_interval == "function")
              child.stop_interval();
         }
     },
     start_interval() {
         let allrefs = Object.keys(this.$refs) ;
         for ( let c of allrefs ) {
           let child = this.$refs[c] ;
           if (! child) continue ;
           if (typeof child.start_interval == "function")
              child.start_interval();
         }
     },
     getframe() {
        return document.getElementById("IFRAME01");
     },
     swapinfo(pswline) { 
        let frame1 = document.getElementById("IFRAME01");
        if (! frame1) 
            return alert ("IFRAME01 not found") ;

        this.$store.commit("reqswapdata",  pswline) ;
        let swap = this.$store.getters.getswap_byid (pswline) ;

        let myframe = frame1.contentWindow.document;
        myframe.open() 
        if (! swap || typeof swap.sdata == "undefined" || swap.sdata.RC != "00" 
                || typeof swap.sdata.txdata == "undefined" || ! swap.speedo ) {
            myframe.write (`<h1>PSWLINE ${pswline} DOWN</h1>`) ;
            return myframe.close();
        }

        myframe.write (`<h1>PSW ${pswline} ${swap.name} VER: ${swap.speedo.version} </h1>`) ;
        myframe.write (`<h3>STARTTIME : ${swap.sdata.txdata.starttime}</h3>`);

        myframe.write ("<table border=1>") ;

        if (swap.usesim) {
           myframe.write ("<h3>SWAP SIMULATOR</h3>") ;
           myframe.write (JSON.stringify(swap.usesim));
        }

        if (swap.sdata.RC != "00") {
            myframe.write (`<h3>LAST RETRIEVE DATA RC: ${swap.sdata.RC} </h3>`) ;
            return myframe.close();
        }

        myframe.write ("<h3>CONNECTIONS</h3>") ;
        let logaddr = swap.sdata.logaddr;
        myframe.write ("<table border=1>") ;
        for (let i = 0 ; i < logaddr.length ; i+= 15) {
            myframe.write ("<tr>") ;
            for (let j = i ; j < i + 15 && j < logaddr.length ; j++) 
                myframe.write (`<td>${logaddr[j].a}:${logaddr[j].s}</td>`) ;
            myframe.write ("</tr>") ;
        }
        myframe.write ("</table>") ;

        myframe.write ("<h3>RESPONSE CODE</h3>") ;
        myframe.write ("<table border=1>") ;

        let lastrcode = swap.speedo["rcode"] ;
        let rcodelist = swap.sdata.txdata["rcode"] ;
        let rcodekeys = Object.keys(rcodelist) ;

        for (let i = 0 ; i < rcodekeys.length ; i+= 5) {
            myframe.write ("<tr>") ;

            let k, last ;
            for (let j = i ; j < i + 5 && j < rcodekeys.length ; j++)  {
                k = rcodekeys[j] ;
                if (k in lastrcode)
                    last = lastrcode[k] ; 
                else
                    last = 0 ;
                myframe.write (`<td>${k}</td><td>${rcodelist[k]} / ${last}</td><td>&nbsp;</td>`) ;
            }
            myframe.write ("</tr>") ;
        }
        myframe.write ("</table>") ;

        myframe.write ("<h3>APPROVAL</h3>") ;

        let approval = swap.sdata.approval ;
        let aprkey  = Object.keys(approval).filter ((a) => { return a != "version" } );
        for (let i = 0 ; i < aprkey.length ; i++) {
            let k = aprkey[i] ;
            /*
            myframe.write ("<div>") ;
            myframe.write (`<p>${k} : ${approval[k].path} ( ${approval[k].auto} ): `) ;
            for (let j = 0 ; j < approval[k].pid.length ; j++) {
              let pid = approval[k].pid[j] ;
              myframe.write (`${pid} `) ;
            }
            myframe.write ("</p></div>") ;
            */
            myframe.write (k + ":") ;
            myframe.write (JSON.stringify(approval[k])) ;
            myframe.write ("<br>") ;
        }
        myframe.write ("</div>") ;

        myframe.write ("<h3>TXDATA</h3>") ;
        myframe.write ("<table border=1>") ;

        let txdata = swap.sdata.txdata ;
        let oldtx  = swap["speedo"].txdata ;
        let txkeys = Object.keys(txdata).filter ((a) => 
            { return ["rcode", "starttime", "c126", "c127" ].indexOf(a) == -1} ) ;

        for (let i = 0 ; i < txkeys.length ; i+= 3) {
            myframe.write ("<tr>") ;

            let k, last ;
            for (let j = i ; j < i + 3 && j < txkeys.length ; j++)  {
                k = txkeys[j] ;
                last = 0 ;
                if (k in oldtx)
                    last = oldtx[k] ;
                let info = k ;
                if (k in txtable)
                    info = txtable[k] ;
                myframe.write (`<td>${info}</td><td>${txdata[k]} / ${last}</td><td>&nbsp;</td>`) ;
            }
            myframe.write ("</tr>") ;
        }
        myframe.write ("</table>") ;
        

        myframe.close() ;
     },
     change_page(newpage) {
       this.$store.commit("changepage", newpage) ; 
     },
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>

